import React, { FunctionComponent } from 'react'
import { connect, useSelector } from 'react-redux'

import { bindActionCreators } from 'redux'

import { PATHWAYS_TYPE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { LyraSelectMicrositeHomePage } from '@lyrahealth-inc/ui-core-crossplatform/src/microsite/pages/lyraSelectMicrositeHomePage/LyraSelectMicrositeHomePage'

import { useComingSoon } from '../../../../common/hooks/useComingSoon'
import { useMicrositeSectionProps } from '../../../../common/hooks/useMicrositeSectionProps'
import { useUpdatedLyraSelectMicrositeConfig } from '../../../../common/hooks/useUpdatedLyraSelectMicrositeConfig'
import { scrollToNextSibling } from '../../../../common/utils/micrositeUtils'
import { getCustomerLaunchDate } from '../../../../data/customer/customerSelectors'
import { trackEventWithObj } from '../../../../data/mixpanel'
import { TrackEventWithObjAction } from '../../../../data/mixpanel/types'

interface LyraSelectComingSoonMicrositeHomeContainerProps {
  actions: {
    trackEventWithObj: TrackEventWithObjAction
  }
}

const LyraSelectComingSoonMicrositeHomeContainer: FunctionComponent<
  LyraSelectComingSoonMicrositeHomeContainerProps
> = ({ actions: { trackEventWithObj } }) => {
  const lyraSelectMicrositeConfig = useUpdatedLyraSelectMicrositeConfig()
  const {
    micrositeSectionProps: {
      faqSectionProps,
      legalAndCopyrightFooterProps,
      membershipSectionProps,
      selfCareSectionProps,
      mobileAppPromoSectionProps,
      mobileAppPromoBannerProps,
    },
  } = useMicrositeSectionProps({ trackEventWithObj, isComingSoon: true })
  const { onNotifyMeOnLaunchPress } = useComingSoon()
  const startDate = useSelector(getCustomerLaunchDate)

  return (
    <LyraSelectMicrositeHomePage
      micrositeConfig={lyraSelectMicrositeConfig}
      selectHomepageHeroSectionProps={{
        onExploreOnYourOwnCTAPress: () => {
          scrollToNextSibling('LyraSelectHeroSection-heroContainer')
        },
        isComingSoon: true,
        onComingSoonPress: onNotifyMeOnLaunchPress,
        startDate: startDate,
      }}
      faqSectionProps={{
        ...faqSectionProps,
        beforeLaunch: true,
        onNotifyMeOnLaunchPress: onNotifyMeOnLaunchPress,
      }}
      legalAndCopyrightFooterProps={legalAndCopyrightFooterProps}
      careNavigatorSectionProps={{
        pathwaysType: PATHWAYS_TYPE.COMING_SOON,
      }}
      membershipSectionProps={membershipSectionProps}
      selfCareSectionProps={{ ...selfCareSectionProps }}
      mobileAppPromoSectionProps={mobileAppPromoSectionProps}
      mobileAppPromoBannerProps={mobileAppPromoBannerProps}
    />
  )
}

function mapDispatchToProps(dispatch: $TSFixMe) {
  return {
    actions: bindActionCreators({ trackEventWithObj }, dispatch),
  }
}

export default connect(null, mapDispatchToProps)(LyraSelectComingSoonMicrositeHomeContainer)
